import React, { useState, useEffect } from 'react';
import logo from '../../assets/img/icons/LogoGuardianNova.png';
import { useRecoilState } from 'recoil';
import { userAtom } from '../../atoms/userAtom';
import loginServices from '../../services/loginServices';
import messages from '../../commons/constMessages';
import toastr from 'toastr';
import '../../assets/css/login.css?v=1.0.0';
import './login.css';

const RESEND_COOLDOWN_SECONDS = 60;
const STORAGE_KEY = 'twoFactorCooldownExpiresAt';

const TwoFactorAuthentication = () => {
  const [token, setToken] = useState('');
  const [user, setUser] = useRecoilState(userAtom);
  const [errorMessage, setErrorMessage] = useState('');
  const [isCooldown, setIsCooldown] = useState(false);
  const [cooldownTimer, setCooldownTimer] = useState(0);

  useEffect(() => {
    const storedExpiration = localStorage.getItem(STORAGE_KEY);
    if (storedExpiration) {
      const expiresAt = parseInt(storedExpiration, 10);
      const now = Date.now();
      const remaining = Math.floor((expiresAt - now) / 1000);

      if (remaining > 0) {
        setIsCooldown(true);
        setCooldownTimer(remaining);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }, []);

  useEffect(() => {
    let cooldownInterval = null;

    if (isCooldown && cooldownTimer > 0) {
      cooldownInterval = setInterval(() => {
        setCooldownTimer(prev => {
          if (prev <= 1) {
            clearInterval(cooldownInterval);
            setIsCooldown(false);
            localStorage.removeItem(STORAGE_KEY);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(cooldownInterval);
  }, [isCooldown, cooldownTimer]);

  const handleChange = e => setToken(e.target.value);

  const ValidateToken = e => {
    e.preventDefault();
    const localUser = { ...user, mfaToken: token };

    loginServices
      .login(localUser)
      .then(data => {
        if (!data.authenticated) {
          setUser({ ...localUser, authError: true });
          setErrorMessage(data.message);
          return;
        }

        setUser({
          ...localUser,
          authError: false,
          name: data.usuario,
          userName: data.usuario,
          isAuth: true,
          accessInfo: data,
          changePassword: data.changePassword
        });
      })
      .catch(() => setErrorMessage(messages.ErrApiNotFound));
  };

  const handleResendToken = async () => {
    if (isCooldown) return;

    const localUser = { ...user, mfaToken: null };
    await loginServices.login(localUser);

    toastr.success('Novo token enviado com sucesso!');
    setErrorMessage('');

    const expiresAt = Date.now() + RESEND_COOLDOWN_SECONDS * 1000;
    localStorage.setItem(STORAGE_KEY, expiresAt.toString());

    setIsCooldown(true);
    setCooldownTimer(RESEND_COOLDOWN_SECONDS);
  };

  const formatTime = seconds => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };

  return (
    <div className="login-bg">
      <div className="container" data-color="purple">
        <div className="row login-row">
          <div className="col-sm-6 col-md-4 col-md-offset-4 d-flex justify-content-center">
            <div className="account-wall">
              <img src={logo} alt="Guardian" className="logo-img" />
              <br />
              <form className="form-signin" onSubmit={ValidateToken}>
                <h5>Digite o token enviado por e-mail:</h5>
                <input
                  type="text"
                  className="form-control"
                  name="token"
                  value={token}
                  onChange={handleChange}
                  placeholder="Token"
                  required
                />

                {errorMessage && (
                  <div className="alert alert-danger login-alert">{errorMessage}</div>
                )}

                <button className="btn btn-lg btn-success btn-block" type="submit">
                  Confirmar
                </button>

                <button
                  type="button"
                  className="btn btn-lg btn-block"
                  onClick={handleResendToken}
                  disabled={isCooldown}
                >
                  {isCooldown
                    ? `Aguarde ${formatTime(cooldownTimer)}`
                    : 'Reenviar código'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFactorAuthentication;